import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import { constants, traveler as travelerUtils } from '@eti/utils';
import { Icon } from '@eti/components';

const { MOUSE_FLOW_CLASS_NAMES } = constants;

const travelerWrapperStyles = css`
  align-items: start;
  display: flex;
  margin-bottom: 10px;

  @media ${mediaQueries.medium.up} {
    flex: 0 0 50%;
    max-width: 50%;
  }
`;

const iconStyles = css`
  flex-shrink: 0;
  height: 16px;
  width: 16px;
`;

const textWrapperStyles = css`
  padding: 0 10px;
`;

const titleStyles = css`
  color: ${etiColors.black};
  font-size: 0.875rem;
  line-height: 16px;

  span {
    font-size: 0.75rem;
    line-height: 12px;
    margin-left: 5px;

    [dir='rtl'] & {
      margin-left: 0;
      margin-right: 5px;
    }
  }
`;

const infoStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.625rem;

  @media ${mediaQueries.medium.up} {
    font-size: 0.75rem;
  }
`;

const ReviewModalTraveler = ({
  ageType,
  countries,
  dateOfBirth,
  firstName,
  lastName,
  mail,
  phone,
  phoneCountry,
  testId,
}) => {
  const { t } = useTranslation();

  const ageTypeIcon = travelerUtils.travelerAgeIcons[ageType];
  const ageTypeLabel = travelerUtils.resolveLabelFromType(
    ageType,
    t('Adult'),
    t('Child'),
    t('Infant'),
  );
  const getPrefix = (countryId) => {
    const country = countries?.find((c) => c.id === countryId);
    return country?.phoneCountryPrefix;
  };
  const formatedPhone = phone ? `+${getPrefix(phoneCountry)} ${phone}` : null;
  const infoItems = [
    { type: 'dateOfBirth', value: dateOfBirth },
    { type: 'mail', value: mail },
    { type: 'phone', value: formatedPhone },
  ];

  return (
    <div className={travelerWrapperStyles} data-testid={testId}>
      <Icon className={iconStyles} color={etiColors.grayScale[6]} id={ageTypeIcon} />
      <div className={cx(textWrapperStyles, MOUSE_FLOW_CLASS_NAMES)}>
        <h3 className={titleStyles}>
          {firstName} {lastName} <span data-testid={`${testId}-ageType`}>{ageTypeLabel}</span>
        </h3>
        {infoItems.map(
          (infoItem) =>
            infoItem.value && (
              <div
                className={infoStyles}
                data-testid={`${testId}-${infoItem.type}`}
                key={`traveler-${infoItem.type}`}
              >
                {infoItem.value}
              </div>
            ),
        )}
      </div>
    </div>
  );
};

ReviewModalTraveler.propTypes = {
  ageType: PropTypes.string,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      phoneCountryId: PropTypes.string,
      phoneCountryPrefix: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  dateOfBirth: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  mail: PropTypes.string,
  phone: PropTypes.string,
  phoneCountry: PropTypes.number,
  testId: PropTypes.string,
};

export default ReviewModalTraveler;
